var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCritical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.875C13.3492 16.875 16.875 13.3492 16.875 9C16.875 4.65076 13.3492 1.125 9 1.125C4.65076 1.125 1.125 4.65076 1.125 9C1.125 13.3492 4.65076 16.875 9 16.875Z",
    fill: "#E53935"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3438 7.3125H3.65625C3.50092 7.3125 3.375 7.43842 3.375 7.59375V10.4062C3.375 10.5616 3.50092 10.6875 3.65625 10.6875H14.3438C14.4991 10.6875 14.625 10.5616 14.625 10.4062V7.59375C14.625 7.43842 14.4991 7.3125 14.3438 7.3125Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCritical);
export default __webpack_public_path__ + "static/media/critical.2d56d6fe20bfe2fed8a20c7f91c0d516.svg";
export { ForwardRef as ReactComponent };